<template>
  <div v-if="allDataLoaded">
    <template v-if="userHasAccess">
      <template v-if="!singleOfferView.visible && !simulationView.visible">
        <div
          v-if="!isReadonly"
          class="flex flex-justify-content-end">
          <f-button
            v-if="inquiryOffers.length"
            class="block mb-3 mt-1 ml-auto"
            theme="dark"
            :disabled="actionInProgress"
            @click="sendBankOffersMail">
            {{ $t('inquiryOffers.notifyCustomerAboutOffer') }}
          </f-button>

          <f-button
            class="block mb-3 mt-1 ml-2"
            theme="primary"
            :disabled="actionInProgress"
            @click="addOffer">
            {{ $t('inquiryOffers.addOffer') }}
          </f-button>
        </div>

        <template v-if="!inquiryOffers.length">
          <f-alert
            v-if="!isReadonly"
            theme="warning"
            visible
            class="">
            {{ $t('inquiryOffers.addTheFirstOffer') }}
            <f-button
              class="ml-auto"
              theme="text-light"
              @click="addOffer">
              {{ $t('inquiryOffers.addOffer') }}
            </f-button>
          </f-alert>

          <f-alert
            v-if="isReadonly"
            theme="warning"
            visible
            class="">
            {{ $t('inquiryOffers.noOffersHaveYet') }}
          </f-alert>
        </template>

        <div
          v-if="inquiryOffers.length"
          class="card mx-auto offers">
          <div class="card-body form-readonly">
            <div
              :class="{
                'inquiry-offers': true,
                'is-readonly': isReadonly}"
              ref="inquiry-offers">
              <div
                class="offers-table common-data">
                <div
                  v-for="(label, labelIndex) in offerLabelsMerged.filter(item => item.common)"
                  :key="labelIndex"
                  class="offers-table-row">
                  <div class="offers-table-row-head mr-2 pr-2 pr-0-xs mr-0-xs mb-1-xs">
                    <span class="my-auto text-bold">{{ label.value }}</span>
                    <f-tooltip
                      v-if="isReadonly && label.tooltip"
                      :parentElementClass="'offers-table-row'"
                      :tooltipName="label.label"
                      :tooltipText="label.tooltip"/>
                  </div>
                  <div class="row-content-wrapper">
                    <div
                      class="row-content pl-2-xs">
                      <template v-if="label.label === 'property_value'">
                        {{ inquiryPropertyValue }}
                      </template>
                      <template v-else-if="label.label === 'need_finishing_amount'">
                        {{ inquiryNeedFinishingAmount }}
                      </template>
                      <template v-else-if="label.label === 'own_contribution'">
                        {{ inquiryOwnContribution }}
                      </template>
                      <template v-else-if="label.label === 'credit_amount'">
                        {{ creditAmount }}
                      </template>
                    </div>
                  </div>
                </div>
              </div>

              <div
                v-if="isArrowsVisible"
                class="flex flex-justify-content-between my-3 relative full-width arrow-wrapper">
                <a
                  @click.prevent="showPrevItem"
                  href="#prev"
                  :class="{
                    'lnk arrow arrow-previous': true,
                    'is-disabled': !isArrowPrevVisible
                  }">
                  &laquo;
                </a>
                <a
                  @click.prevent="showNextItem"
                  href="#next"
                  :class="{
                    'arrow arrow-next': true,
                    'is-disabled': !isArrowNextVisible
                  }">
                  &raquo;
                </a>
              </div>

              <div
                :class="tableClasses">
                <div
                  v-for="(label, labelIndex) in offerLabelsMerged.filter(item => !item.common)"
                  :key="labelIndex"
                  class="offers-table-row">
                  <div
                    :class="{
                      'offers-table-row-head pr-2 pr-0-xs mb-1-xs': true,
                      'offers-table-row-head-grey': !!label.label
                    }">
                    <span
                      :class="{
                        'my-auto text-bold': true,
                        'hidden-mobile-tiny': label.value === $t('inquiry.titleMobile') || label.value === 'Bank'
                      }">
                      {{ label.value }}
                    </span>
                    <f-tooltip
                      v-if="isReadonly && label.tooltip"
                      :parentElementClass="'offers-table-row'"
                      :tooltipName="label.label"
                      :tooltipText="label.tooltip"/>
                  </div>
                  <div
                    :class="{
                      'row-content-wrapper': true,
                      'is-higlighted': isReadonly && (label.value === 'Bank' || label.value === $t('inquiry.titleMobile'))
                    }"
                    :id="labelIndex === 1 ? 'offers-slider' : 'item-id-' + labelIndex"
                    :ref="labelIndex === 1 ? 'offers-slider' : ''">
                    <div class="row-content row-slider"
                      :data-count="inquiryOffers.length"
                      :data-current="currentSliderItem"
                      :style="{ transform: 'translateX(-' + (currentListOffset) + 'px)' }">
                      <div
                        v-for="(offer, offerIndex) in inquiryOffers"
                        :key="'offer-' + offerIndex"
                        :class="{
                          'offers-table-row-cell': true
                        }">
                        <template v-if="label.value === 'Bank'">
                          <span class="block text-center text-size-medium text-medium text-left-sm pl-2-xs">{{ offer.bank_name }}</span>
                        </template>
                        <template v-else-if="label.value === $t('inquiry.titleMobile')">
                          <span class="block text-center text-medium text-left-sm pl-2-xs">{{ $t('inquiry.titleMobile') }}: {{ userType === 'customer' ? offer.customer_description_bank_offer || '-' : offer.bank_offer_name }}</span>
                          <span
                            v-if="offer.bank_offer_variant_id"
                            class="block text-center text-medium text-left-sm pl-2-xs">
                            {{ $t('ui.variant') }}: {{ userType === 'customer' ? offer.customer_description_bank_variant_offer || '-' : offer.bank_offer_variant_name }}
                          </span>
                        </template>
                        <template v-else-if="label.value === $t('ui.action')">
                          <div
                            :class="{
                              'flex full-width pl-2-xs': true,
                              'flex-justify-content-around flex-wrap': isReadonly
                              }">
                            <template v-if="isReadonly">
                              <f-button
                                theme="text"
                                class="mx-1 px-0"
                                :disabled="removeInProgress"
                                @click.prevent.native="showSimulation(offer)">
                                {{ $t('inquiryOffers.simulationInstallmentVariable') }}
                              </f-button>
                              <f-button
                                theme="text"
                                class="mx-1 px-0"
                                :disabled="removeInProgress"
                                @click.prevent.native="showSimulation(offer, 'fixed')">
                                {{ $t('inquiryOffers.simulationInstallmentFixed') }}
                              </f-button>
                            </template>
                            <template v-else>
                              <f-button
                                theme="text"
                                class="ml-auto ml-0-xs pl-0-xs mr-2"
                                :disabled="removeInProgress"
                                @click.prevent.native="editOffer(offer)">
                                {{ $t('ui.edit') }}
                              </f-button>
                              <f-button
                                theme="text-alert"
                                class="mr-auto"
                                :disabled="removeInProgress"
                                @click.prevent.native="removeOffer(offer)">
                                {{ $t('ui.remove') }}
                              </f-button>
                            </template>
                          </div>
                        </template>
                        <template v-else>
                          <span class="block text-center text-size-medium text-left-sm pl-2-xs">{{ offer[label.label] }} {{ label.append }}</span>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-else-if="singleOfferView.visible && !simulationView.visible">
        <inquiry-offer-form
          :offerID="singleOfferView.offerID"
          :inquiryID="inquiryID"
          :inquiryPropertyValue="inquiryPropertyValue"
          :inquiryNeedFinishingAmount="inquiryNeedFinishingAmount"
          :inquiryOwnContribution="inquiryOwnContribution"
          :allBankOffersForInquiry="allBankOffersForInquiry"
          :preferedBanks="preferedBanksIDs"
          :labels="offerLabelsMerged"
          :offersInUse="offersInUse"
          :isReadonly="isReadonly" />
      </template>
      <template v-else>
        <inquiry-offer-loan-simulation
          :lending-rate-type="simulationView.lendingRateType"
          :offer="simulationView.offer" />
      </template>
    </template>
    <f-alert
      v-else
      visible
      class="my-5"
      theme="inactive">
      <span>
      {{ $t('user.currentPackageDoesNotIncludeAccessToSection') }}
      </span>
    </f-alert>
  </div>
</template>
<script>
import debounce from 'lodash.debounce';
import Vue from 'vue';
import FormUtils from '@/utils/FormUtils.js';
import ListUtils from '@/utils/ListUtils.js';
import InquiryOfferForm from '@/views/forms/inquiry/InquiryOfferForm.vue';
import InquiryOfferLoanSimulation from '@/views/forms/inquiry/InquiryOfferLoanSimulation.vue';

export default {
  name: 'inquiry-offers',
  components: {
    'inquiry-offer-form': InquiryOfferForm,
    'inquiry-offer-loan-simulation': InquiryOfferLoanSimulation
  },
  props: {
    inquiryID: {
      type: Number,
      required: true
    },
    inquiryPropertyValue: {
      type: Number,
      required: true
    },
    inquiryNeedFinishingAmount: {
      type: Number,
      required: true
    },
    inquiryOwnContribution: {
      type: Number,
      required: true
    },
    isReadonly: {
      type: Boolean,
      required: true
    },
    isTabVisible: {
      type: Boolean,
      required: true
    },
    offerLabels: {
      type: Array,
      required: true
    },
    preferedBanks: {
      type: Array,
      required: true
    }
  },
  computed: {
    userHasAccess () {
      return this.$store.getters.getUserHasFeature('credit_offer');
    },
    allDataLoaded () {
      if (!this.userHasAccess) {
        return true;
      }
      return this.loaded && this.allBankOffersForInquiryLoaded;
    },
    preferedBanksIDs () {
      if (!this.preferedBanks.length) {
        return [];
      }

      return this.preferedBanks.map(item => item.id);
    },
    offerLabelsMerged () {
      let mergedArray = [];
      for (let i = 0; i < this.defaultLabels.length; i++) {
        let labelFromInquiry = this.offerLabels.find(item => item.label === this.defaultLabels[i].label);
        mergedArray.push({ ...this.defaultLabels[i], ...labelFromInquiry });
      }

      return mergedArray;
    },
    offersInUse () {
      let offeresInUse = this.inquiryOffers.map(item => {
        let newObj = {
          offerID: item.bank_offer_id,
          offerVariantID: item.bank_offer_variant_id
        };
        return newObj;
      });
      return offeresInUse;
    },
    creditAmount () {
      let loanAmount = Number(this.inquiryPropertyValue) + Number(this.inquiryNeedFinishingAmount);
      let ownContribution = this.inquiryOwnContribution > 0 ? (this.inquiryOwnContribution / 100) * loanAmount : 0;
      return Number((loanAmount - ownContribution).toFixed(2));
    },
    tableClasses () {
      let classes = ['offers-table', 'with-slider', `rows-count-${this.inquiryOffers.length}`];
      if (!this.isArrowsVisible) {
        classes.push('mt-5');
      }
      return classes.join(' ');
    },
    listFullWidth () {
      return this.sliderItemWidth * this.inquiryOffers.length;
    },
    isArrowPrevVisible () {
      if (!this.sliderList || (this.currentSliderItem === 0) || (this.listFullWidth <= this.sliderListWidth)) {
        return false;
      }

      return true;
    },
    isArrowsVisible () {
      if ((this.windowWidth > 1130 && this.offersCount <= 3)) {
        return false;
      }

      if ((this.windowWidth > 720 && this.windowWidth <= 1130 && this.offersCount <= 2)) {
        return false;
      }

      if (this.offersCount <= 1) {
        return false;
      }

      return true;
    },
    isArrowNextVisible () {
      if (!this.sliderList) {
        return false;
      }
      if (this.currentSliderItem === this.inquiryOffers.length - 1) {
        return false;
      }
      if (this.listFullWidth <= (this.sliderListWidth + 10)) {
        return false;
      }
      if (this.currentListOffset >= ((this.listFullWidth - this.sliderListWidth) - 5)) {
        return false;
      }

      return true;
    },
    currentListOffset () {
      return this.currentSliderItem * this.sliderItemWidth;
    },
    sliderListWidth () {
      if (!this.windowWidth || !this.sliderList || !this.offersCount) {
        return 0;
      }

      return this.sliderList.offsetWidth;
    }
  },
  watch: {
    'inquiryOffers': function () {
      this.setItemsWidth();
    },
    offersVisible () {
      this.setItemsWidth();
    },
    allDataLoaded () {
      this.setItemsWidth();
    },
    userHasAccess (newValue) {
      if (newValue && !this.viewInitiated) {
        this.initView();
      }
    }
  },
  data() {
    return {
      allBankOffersForInquiry: [],
      allBankOffersForInquiryLoaded: false,
      inquiryOffers: [],
      userType: null,
      loaded: false,
      loadError: false,
      removeInProgress: false,
      defaultLabels: [
        {
          label: 'property_value',
          value: this.$t('inquiryOffers.propertyPrice'),
          common: true,
          append: 'PLN'
        },
        {
          label: 'need_finishing_amount',
          value: this.$t('inquiryOffers.finishing'),
          common: true,
          append: 'PLN'
        },
        {
          label: 'own_contribution',
          value: this.$t('inquiryOffers.ownContribution'),
          common: true,
          append: '%'
        },
        {
          label: 'credit_amount',
          value: this.$t('inquiryOfferLoanSimulation.creditAmount'),
          common: true,
          append: 'PLN'
        },
        {
          value: this.$t('ui.action')
        },
        {
          value: this.$t('ui.bank')
        },
        {
          value: this.$t('inquiry.titleMobile')
        },
        {
          label: 'commission',
          value: this.$t('inquiryOfferForm.commission'),
          common: false,
          append: '%',
          rules: 'required|min_value:0'
        },
        {
          label: 'margin',
          value: this.$t('inquiryOfferForm.margin'),
          common: false,
          append: '%',
          rules: 'required|min_value:0'
        },
        {
          label: 'wibor',
          value: this.$t('inquiryOfferForm.wibor'),
          common: false,
          append: '%',
          rules: 'required|min_value:0'
        },
        {
          label: 'lending_rate',
          value: this.$t('inquiryOffers.lendingRateValue'),
          common: false,
          append: '%',
          rules: 'required|min_value:0'
        },
        {
          label: 'fixed_lending_rate',
          value: this.$t('inquiryOffers.fixedLendingRate'),
          common: false,
          append: '%',
          rules: 'required|min_value:0'
        },
        {
          label: 'loan_installment',
          value: this.$t('inquiryOffers.loanInstallmentValue'),
          common: false,
          append: 'PLN',
          rules: 'required|min_value:0'
        },
        {
          label: 'fixed_loan_installment',
          value: this.$t('inquiryOffers.fixedLoanInstallment'),
          common: false,
          append: 'PLN',
          rules: 'required|min_value:0'
        },
        {
          label: 'bridging_insurance',
          value: this.$t('inquiryOffers.bridgingInsurance'),
          common: false
        },
        {
          label: 'life_insurance',
          value: this.$t('inquiryOffers.lifeInsuranceValue'),
          common: false
        },
        {
          label: 'work_insurance',
          value: this.$t('inquiryOffers.workInsuranceValue'),
          common: false
        },
        {
          label: 'property_insurance',
          value: this.$t('inquiryOffers.propertyInsuranceValue'),
          common: false
        },
        {
          label: 'valuation',
          value: this.$t('inquiryOffers.valuation'),
          common: false
        },
        {
          label: 'early_repayment',
          value: this.$t('inquiryOffers.earlyRepaymentValue'),
          common: false
        },
        {
          label: 'early_overpayment',
          value: this.$t('inquiryOffers.earlyOverpaymentValue'),
          common: false
        }
      ],
      singleOfferView: {
        visible: false,
        offerID: null
      },
      simulationView: {
        lendingRateType: null,
        offer: null,
        visible: false
      },
      currentSliderItem: 0,
      windowWidth: null,
      offersVisible: false,
      offersCount: 0,
      sliderItemWidth: 0,
      sliderList: null,
      actionInProgress: false,
      viewInitiated: false
    };
  },
  mounted () {
    this.$bus.$on('inquiry-offers-reload', this.loadItemsData);
    this.$bus.$on('inquiry-offers-show-list', this.showList);
    this.$bus.$on('offers-tab-visible', this.triggerOffersVisible);
    this.userType = this.$store.getters['getUserType'].toLowerCase();
    if (this.userHasAccess) {
      this.initView();
    }
    this.windowWidth = window.innerWidth;
  },
  methods: {
    initView () {
      Vue.set(this, 'viewInitiated', true);
      window.addEventListener('resize', this.debouncedResizeHandler);
      this.loadItemsData();
      if (!this.isReadonly) {
        this.loadBankOffersForInquiry();
      } else {
        this.allBankOffersForInquiryLoaded = true;
      }
    },
    loadItemsData () {
      Vue.set(this, 'loaded', false);

      let endpointUrl = '';

      if (this.isReadonly) {
        endpointUrl = '/api/customer/inquiries/bank-offers/items';
      } else {
        endpointUrl = '/api/adviser/inquiries/bank-offers/items';
      }

      ListUtils.loadItemsData(this, {
        method: 'get',
        endpoint: endpointUrl,
        listField: 'inquiryOffers',
        pagination: false,
        errorKey: 'loadError',
        params: {
          where: {
            inquiry_id: this.inquiryID
          }
        },
        successAction: () => {
          Vue.nextTick(() => {
            Vue.set(this, 'singleOfferView', { visible: false, offerID: null });
            Vue.set(this, 'simulationView', {
              lendingRateType: null,
              offer: null,
              visible: false
            });
            this.windowWidth = window.innerWidth;

            if (this.isTabVisible) {
              Vue.set(this, 'offersVisible', true);
            }
          });
        },
        failAction: () => {
          Vue.nextTick(() => {
            Vue.set(this, 'singleOfferView', { visible: false, offerID: null });
            Vue.set(this, 'simulationView', {
              lendingRateType: null,
              offer: null,
              visible: false
            });

            if (this.isTabVisible) {
              Vue.set(this, 'offersVisible', true);
            }
          });
        }
      });
    },
    loadBankOffersForInquiry () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/api/adviser/inquiries/bank-offers/search/' + this.inquiryID,
        method: 'get',
        outputKey: 'allBankOffersForInquiry',
        loadedKey: 'allBankOffersForInquiryLoaded',
        errorKey: 'loadError',
        successAction: () => {
          Vue.nextTick(() => {
            this.windowWidth = window.innerWidth;
          })
        }
      });
    },
    addOffer () {
      Vue.set(this, 'singleOfferView', { visible: true, offerID: null });
    },
    editOffer (offer) {
      Vue.set(this, 'singleOfferView', { visible: true, offerID: offer.id });
    },
    showSimulation (offerForSimulation, type = '') {
      Vue.set(this, 'simulationView', {
        lendingRateType: type,
        offer: offerForSimulation,
        visible: true
      });
    },
    removeOffer (offer) {
      this.removeInProgress = true;
      let offerId = typeof offer === 'object' ? offer.id : offer;

      ListUtils.removeItem(this, {
        endpointBase: '/api/adviser/inquiries/bank-offers/delete/',
        id: offerId,
        successTitle: this.$t('inquiriesList.deleteOffer'),
        successText: this.$t('inquiriesList.selectOfferDelete'),
        confirmTitle: this.$t('inquiriesList.areYouSureDeleteOffer'),
        confirmText: this.$t('ui.thisOperationCannotUndone'),
        errorTitle: this.$t('ui.errorOccurred'),
        errorText: this.$t('inquiriesList.deleteOfferError'),
        successAction: () => {
          this.removeInProgress = false;
          this.loadItemsData();
        },
        cancelAction: () => {
          this.removeInProgress = false;
        }
      });
    },
    showList () {
      Vue.set(this, 'singleOfferView', { visible: false, offerID: null });
      Vue.set(this, 'simulationView', {
        lendingRateType: null,
        offer: null,
        visible: false
      });
      this.triggerOffersVisible();
    },
    showNextItem () {
      Vue.nextTick(() => {
        if (this.currentSliderItem < this.inquiryOffers.length) {
          Vue.set(this, 'currentSliderItem', this.currentSliderItem + 1);
        }
      });
    },
    showPrevItem () {
      Vue.nextTick(() => {
        if (this.currentSliderItem > 0) {
          Vue.set(this, 'currentSliderItem', this.currentSliderItem - 1);
        }
      });
    },
    triggerOffersVisible () {
      Vue.nextTick(() => {
        Vue.set(this, 'offersVisible', true);
      });
    },
    getSliderList () {
      if (!this.loaded || !this.offersVisible || !this.$refs || !this.$refs['offers-slider']) {
        return null;
      }

      let sliderList = this.$refs['offers-slider'];

      if (Array.isArray(sliderList)) {
        sliderList = sliderList[0];
      }

      return sliderList;
    },
    setItemsWidth () {
      Vue.nextTick(() => {
        this.sliderList = this.getSliderList();

        Vue.set(this, 'offersCount', this.inquiryOffers.length);
        Vue.set(this, 'currentSliderItem', 0);

        if (this.sliderList) {
          setTimeout(() => {
            let item = this.sliderList.querySelector('.row-slider .offers-table-row-cell');
            if (item) {
              Vue.set(this, 'sliderItemWidth', item.offsetWidth);
            }
          }, 500);
        }
      })
    },
    sendBankOffersMail () {
      this.actionInProgress = true;

      FormUtils.submitWithConfirm(this, {
        endpoint: '/api/adviser/inquiries/send-bank-offers-mail/' + this.inquiryID,
        formData: {},
        successTitle: this.$t('inquiryOffers.messageSendSuccess'),
        successText: this.$t('inquiryOffers.messageSendSuccessAboutOffers'),
        errorTitle: this.$t('ui.errorOccurred'),
        errorText: this.$t('inquiryOffers.messageSendError'),
        confirmTitle: this.$t('inquiryOffers.areYouSureToSendMessage'),
        confirmText: this.$t('inquiryOffers.sendMessageChangeStatus'),
        confirmButtonText: this.$t('ui.yesSend'),
        successAction: () => {
          this.actionInProgress = false;
          this.$bus.$emit('inquiry-reload', 'inquiry-offers');
        },
        failAction: () => {
          this.actionInProgress = false;
        }
      });
    },
    debouncedResizeHandler: debounce(function () {
      Vue.set(this, 'windowWidth', window.innerWidth);
      Vue.set(this, 'currentSliderItem', 0);
      if (this.sliderList) {
        setTimeout(() => {
          let item = this.sliderList.querySelector('.row-slider .offers-table-row-cell');
          if (item) {
            Vue.set(this, 'sliderItemWidth', item.offsetWidth);
          }
        }, 220);
      }
    }, 250)
  },
  beforeDestroy () {
    window.addEventListener('resize', this.debouncedResizeHandler);
    this.$bus.$off('inquiry-offers-reload', this.loadItemsData);
    this.$bus.$off('inquiry-offers-show-list', this.showList);
    this.$bus.$off('offers-tab-visible', this.triggerOffersVisible);
  }
}
</script>
